import React, { useCallback, useEffect, useState } from "react";
import api from "../../helpers/api";
import { Select, Option } from "../../Korbantech/components/Inputs/Select";
import { Cause } from "../../types/Causes";

interface OptionHelper extends Option {
    checked?: boolean;
}
interface CausesHelper extends Cause {
    checked?: boolean;
}

export const FiltersOsc = () => {
    const [state, setState] = useState<OptionHelper[]>([]);
    const [city, setCity] = useState<OptionHelper[]>([]);
    const [causes, setCauses] = useState<CausesHelper[]>([]);
    const [regions, setRegions] = useState<OptionHelper[]>([]);

    const loadState = useCallback(async () => {
        await api
            .get("/locations/states", { params: { select: true } })
            .then((res) => {
                setState(res.data);
            })
            .catch(console.log);
            await api
            .get("/locations/regions")
            .then((res) => {
                setRegions(res.data);
            })
            .catch(console.log);
            await api.get("/causes").then((res) => {
                setCauses(res.data);
            }).catch(console.log);
    }, []);

    useEffect(() => {
        loadState();
    }, [loadState]);
    
    return (
        <div className="grid grid-cols-5 gap-x-2 my-5">
            <div>
                <div className="font-semibold">Cidade</div>
                <Select
                    multiple
                    selectLabel="Cidade"
                    selected={city.filter((c) => c.checked).map((c) => c.value)}
                    options={city}
                    onChange={(opt) =>{
                        setCity((prev) =>
                            prev.map((p) =>
                                opt.includes(p.value)
                                    ? { ...p, checked: true }
                                    : { ...p, checked: false }
                            )
                        )}
                        
                    }
                />
            </div>
            <div>
                <div className="font-semibold">Estado</div>
                <Select
                    multiple
                    selectLabel="Estado"
                    selected={state
                        .filter((c) => c.checked)
                        .map((c) => c.value)}
                    options={state}
                    onChange={(opt) =>
                        setState((prev) =>
                            prev.map((p) =>
                                opt.includes(p.value)
                                    ? { ...p, checked: true }
                                    : { ...p, checked: false }
                            )
                        )
                    }
                />
            </div>
            <div>
                <div className="font-semibold">Região</div>
                <Select
                    multiple
                    selectLabel="Região"
                    selected={regions.filter((c) => c.checked).map((c) => c.value)}
                    options={regions}
                    onChange={(opt) =>
                        setRegions((prev) =>
                            prev.map((p) =>
                                opt.includes(p.value)
                                    ? { ...p, checked: true }
                                    : { ...p, checked: false }
                            )
                        )
                    }
                />
            </div>
            <div>
                <div className="font-semibold">Causa</div>
                <Select
                    multiple
                    selectLabel="Causa"
                    selected={causes.filter((c) => c.checked).map((c) => c.id)}
                    options={causes.map((c) => ({
                        label: c.name,
                        value: c.id,
                    }))}
                    onChange={(opt) =>
                        setCauses((prev) =>
                            prev.map((p) =>
                                opt.includes(p.id)
                                    ? { ...p, checked: true }
                                    : { ...p, checked: false }
                            )
                        )
                    }
                />
            </div>
        </div>
    );
};
